import gql from 'graphql-tag';

export const GetPromotedSpacesQuery = gql`
	query GetPromotedSpacesQuery($promotedSpaceKey: String) @experimental {
		experimentalPromotedSpaces(
			promotedSpacesLimit: 1
			otherSpacesLimit: 1
			promotedSpaceKey: $promotedSpaceKey
		) {
			nodes {
				id
			}
			matchedPromotedSpaces {
				id
			}
		}
	}
`;
